import React from 'react';
import { useTranslation } from 'react-i18next';
import './schedule.css';
import Icon from './icons';

function Fallback({ onRetry }) {
  const { t, i18n } = useTranslation();
  const ar = !(i18n.language || 'ar').startsWith('en');
  return (
    <div className="sch6" dir={ar ? 'rtl' : 'ltr'} lang={ar ? 'ar' : 'en'}>
      <div className="sch6-main"><div className="sch6-main-in">
        <div className="sch6-errbox" role="alert">
          <Icon name="alert" />
          <div>
            <b>{t('sch6.crash_title')}</b>
            <div style={{ marginTop: 10 }}><button type="button" className="sch6-btn" onClick={onRetry}>{t('sch6.retry')}</button></div>
          </div>
        </div>
      </div></div>
    </div>
  );
}

/**
 * A render error anywhere in the schedule page shows a message and a retry instead of an empty screen (React unmounts the whole
 * tree on an uncaught render error, and nothing would ever bring it back). «Retry» renders the page again and calls `onReset`
 * (the container refetches its data).
 */
export default class ScheduleBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
    this.retry = this.retry.bind(this);
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[schedule] render failed', error, info?.componentStack);
  }

  retry() {
    if (this.props.onReset) this.props.onReset();
    this.setState({ failed: false });
  }

  render() {
    return this.state.failed ? <Fallback onRetry={this.retry} /> : this.props.children;
  }
}
